import styles from "./events.module.css";
import EventTimeline from "../../components/events/EventTimeline";
const Events = () => {
    return (
        <div>
            <div className={styles.upper}>
               <div className={styles.mainhead}></div>
               <div className={styles.homeimage}><img src="./images/eventsHome/coverImage2.png" alt="TeamImage"/></div>
            </div>
            <EventTimeline></EventTimeline>
        </div>
    );
}
 
export default Events;